import { render, staticRenderFns } from "./FundKLine.vue?vue&type=template&id=a56b9b9c&scoped=true&"
import script from "./FundKLine.vue?vue&type=script&lang=js&"
export * from "./FundKLine.vue?vue&type=script&lang=js&"
import style0 from "./FundKLine.vue?vue&type=style&index=0&id=a56b9b9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56b9b9c",
  null
  
)

export default component.exports